import { DataSource, Label, Layout, } from "@mcleod/components";

export abstract class AutogenLayoutHoldReasonQuickInfo extends Layout {
    labelReason: Label;
    sourceOrders: DataSource;
}
